module.exports = __webpack_public_path__ + "dingbeauty-build/img/calender_arrow_left.5d6f04a6.svg";